/**
 * @Author: 左建
 * @Date: 2022/11/28 16:50
 * @LastEditTime: 2022/11/28 16:50
 * @Description: 统计页面静态配置文件
*/

export const STAT_DATA = Object.freeze([
    {
        label: "学员总数",
        value: "Student",
        unit: "人",
        icon: require("@/assets/img/admin/statistic/icon-student.png")
    },
    {
        label: "试题总数",
        value: "Subject",
        unit: "道",
        icon: require("@/assets/img/admin/statistic/icon-question.png")
    },
    {
        label: "试卷总数",
        value: "ExamPaper",
        unit: "套",
        icon: require("@/assets/img/admin/statistic/icon-paper.png")
    },
    {
        label: "考试场数",
        value: "Exam",
        unit: "场",
        icon: require("@/assets/img/admin/statistic/icon-exam.png")
    }
])

// chart模拟数据
export const CHART_DATA = Array.from({ length: 10 }, (_,i) => {
    return {
        groupName: "分组" + i,
        lineValue: Math.ceil(Math.random() * 100),
        barValue: Math.floor(Math.random() * 100)
    }
})
